import { Component, OnInit } from '@angular/core';
import {Api, User} from '../../providers';
import {ModalController} from '@ionic/angular';

@Component({
  selector: 'app-history',
  templateUrl: './history.page.html',
  styleUrls: ['./history.page.scss'],
})
export class HistoryPage implements OnInit {
    public listLoding:boolean=true;
    public days:any=[];
    public data;
    public dates:any=[];
    public date;
    public price:any;
    public day;
    public month;
    public year;
    constructor( public api:Api, public user: User,public modalController: ModalController) {

    }

  ngOnInit() {
      this.getDate();
      // for(var i=1;i<=31;i++){
      //
      //     this.days.push(i);
      // }
  }
  async getDate(){
      await this.user.myLoading()
      this.api.post("history", { userKey: this.user.account.userKey,type:"date",pdid:this.price.priceData.id}).subscribe(res => {
          this.dates=res["data"];
          this.user.dismissLoading();
      },()=>{
          this.user.dismissLoading();
      });
  }
    async getData() {
      if(this.date){
          await this.user.myLoading()
          this.api.post("history", { userKey: this.user.account.userKey,type:"data",date:this.date,pdid:this.price.priceData.id}).subscribe(res => {
              this.data=res["data"];
              this.user.dismissLoading();
          },()=>{
              this.user.dismissLoading()
          });
      }
    }
    public dismissModal() {
        // using the injected ModalController this page
        // can "dismiss" itself and optionally pass back data
        this.modalController.dismiss({
            'dismissed': true
        });
    }
}
